/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-12T15:54:15.659
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentChannelApply,
	listRentChannelApplyInit,
	listRentChannelApplyByAuthorizations,
	deleteRentChannelApply
	
} from '@api/rentmanage/RentChannelApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
		//是否编辑状态查看
		edit:true
	},

	actions: {
		listRentChannelApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentChannelApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentChannelApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentChannelApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentChannelApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentChannelApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentChannelApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentChannelApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
